export default "__VITE_ASSET__D38gj0Be__"